// extracted by mini-css-extract-plugin
export default {"facilityCategory":"facility_category_facilityCategory__C0X7h","facilityCategoryTitle":"facility_category_facilityCategoryTitle__XD+ct"};